import React, { useState } from 'react';
import { LinkAttributes } from 'remirror/extensions';
import {
  FloatingWrapper,
  useCommands,
  useCurrentSelection,
  useEditorState,
  useUpdateReason,
} from '@remirror/react';
import { Button, useColorModeValue, VStack } from '@cardboard-ui/react';
import { t } from '@lingui/macro';

const PasteLinkMenu = () => {
  const selection = useCurrentSelection();
  const state = useEditorState();
  const commands = useCommands();
  const updateReason = useUpdateReason();
  const [showDialog, setShowDialog] = useState(false);
  const bg = useColorModeValue('gray.200', 'gray.800');

  if (!selection || selection.from <= 0) {
    return null;
  }

  const node = state.doc.nodeAt(selection.from - 1);
  const mark = node?.marks.find(
    (mark) =>
      mark.type.name === 'link' && mark.attrs.auto && !mark.attrs.dismissed,
  );
  if (mark && updateReason.doc && !showDialog) {
    setShowDialog(true);
  } else if (!mark && showDialog) {
    setShowDialog(false);
  }

  const handleDismiss = () => {
    setShowDialog(false);
    if (mark) {
      commands.dismissLink(mark.attrs as LinkAttributes, selection.from - 1);
    }
  };

  const handleCreateLinkCard = () => {
    setShowDialog(false);
    commands.replaceLinkWithLinkCard(selection.from - 1, mark?.attrs.href);
  };

  return (
    <FloatingWrapper
      positioner="always"
      renderOutsideEditor
      placement="bottom-start"
      enabled={showDialog}
    >
      <VStack p={2} bg={bg} borderRadius="lg">
        <Button size="sm" w="100%" onClick={handleDismiss}>{t`Dismiss`}</Button>
        <Button size="sm" w="100%" onClick={handleCreateLinkCard}>
          {t`Create Link Card`}
        </Button>
      </VStack>
    </FloatingWrapper>
  );
};

export default PasteLinkMenu;
